import { render, staticRenderFns } from "./FormUpdateButton.vue?vue&type=template&id=3eb5b3ba&"
import script from "./FormUpdateButton.vue?vue&type=script&lang=js&"
export * from "./FormUpdateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports